import get from 'lodash/get';
import { from, firstValueFrom } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import store from '@Store';
import { getProjectsInfoMap } from '@Pages/RetroSynthesis/RsBreadcrumbs/selector';
import { ProjectRoutesCountMapState } from '@Pages/RetroSynthesis/RsBreadcrumbs/reducer';
import { routeType as routeTypeSelector } from '@Pages/RetroSynthesis/ProjectRoute/selectors';
import { RouteType } from '@Pages/RetroSynthesis/constants';

const projectsPageName = 'My Retrosynthesis projects';

const getProjectInfoFromState = (state, projectId) => {
  const projectsInfoMap = getProjectsInfoMap(state);
  return projectsInfoMap && projectsInfoMap[projectId];
};

export async function projectMapper({ projectId }) {
  let projectInfo = getProjectInfoFromState(store.getState(), projectId);

  if (get(projectInfo, 'projectName')) {
    return {
      title: projectInfo.projectName,
      pageName: projectsPageName,
    };
  }

  projectInfo = await firstValueFrom(
    from(store).pipe(
      filter((state) => {
        const projectInfoFromState = getProjectInfoFromState(state, projectId);
        return projectInfoFromState && projectInfoFromState !== ProjectRoutesCountMapState.LOADING;
      }),
      map((state) => getProjectInfoFromState(state, projectId)),
      take(1)
    )
  );

  return {
    title: projectInfo !== ProjectRoutesCountMapState.ERROR ? projectInfo.projectName : `Project #${projectId}`,
    pageName: projectsPageName,
  };
}

export async function routeMapper({ routeId }) {
  let routeType = routeTypeSelector(store.getState());

  if (routeType) {
    return {
      title: `Route #${routeId} ${RouteType.trackingMap[routeType]}`,
      pageName: projectsPageName,
    };
  }

  routeType = await firstValueFrom(from(store).pipe(filter(routeTypeSelector), map(routeTypeSelector), take(1)));

  return {
    title: `Route #${routeId} ${RouteType.trackingMap[routeType]}`,
    pageName: projectsPageName,
  };
}
